import { createAction, props } from '@ngrx/store';
import { GlobalPayload } from './global.model';

export enum GlobalActionTypes {
  LOAD_GLOBAL = '[Global] Load global settings',
  LOAD_GLOBAL_SUCCESS = '[Global] Load global settings Success',

  SET_FAILURE = '[Global] Failure',
}

export const LoadGlobalConst = createAction(GlobalActionTypes.LOAD_GLOBAL);

export const LoadGlobalConstSuccess = createAction(
  GlobalActionTypes.LOAD_GLOBAL_SUCCESS,
  props<GlobalPayload>(),
);
export const LoadGlobalConstFailure = createAction(
  GlobalActionTypes.SET_FAILURE,
  props<{ error: Error }>(),
);
